import { useEffect, useState } from "react";
import { api, fmtUsd } from "@/lib/nexus";

export default function StackOverlay() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/stack/matrix").then((r) => setData(r.data));
  }, []);
  if (!data) return <div className="p-4 text-nexus-text-2">Loading…</div>;

  const { matrix, frameworks, chains } = data;

  const cellColor = (v) => {
    if (!v) return "";
    if (v.critical > 0) return "border-nexus-rose/60 text-nexus-rose bg-nexus-rose/5";
    if (v.count >= 3) return "border-nexus-cyan/50 text-nexus-cyan bg-nexus-cyan/5";
    return "border-nexus-border text-nexus-text-2";
  };

  return (
    <div className="p-4 space-y-4">
      <div>
        <div className="panel-title">STACK OVERLAY // AGENTIC INFRA × ON-CHAIN</div>
        <h1 className="font-rajdhani font-bold text-2xl tracking-tight mt-1">
          Which agent stacks operate <span className="text-nexus-cyan">on which chains</span>
        </h1>
        <div className="text-[12px] text-nexus-text-2 mt-2 max-w-2xl">
          Overlay of agent frameworks across supported blockchains. Cell intensity indicates active agent density,
          red cells contain wallets flagged as critical.
        </div>
      </div>

      <div className="panel overflow-auto brackets">
        <span className="b1" /><span className="b2" />
        <table className="w-full">
          <thead>
            <tr className="border-b border-nexus-border">
              <th className="text-left p-3 panel-title min-w-[140px]">Framework ↓ / Chain →</th>
              {chains.map((c) => (
                <th key={c} className="p-3 panel-title text-center">{c}</th>
              ))}
              <th className="p-3 panel-title text-center">Σ Agents</th>
            </tr>
          </thead>
          <tbody>
            {frameworks.map((fw) => {
              const totalAgents = Object.values(matrix[fw] || {}).reduce((s, x) => s + x.count, 0);
              return (
                <tr key={fw} data-testid={`stack-row-${fw}`} className="border-b border-nexus-border/60">
                  <td className="p-3 font-rajdhani uppercase tracking-widest text-nexus-violet text-[13px] font-semibold">{fw}</td>
                  {chains.map((c) => {
                    const cell = matrix[fw]?.[c];
                    return (
                      <td key={c} className="p-2 text-center">
                        {cell ? (
                          <div className={`border ${cellColor(cell)} p-2 font-mono text-[11px]`}>
                            <div className="text-[16px] font-rajdhani font-bold">{cell.count}</div>
                            <div className="text-[9px] uppercase tracking-widest opacity-70">{fmtUsd(cell.tvl)}</div>
                            {cell.critical > 0 && <div className="text-[9px] text-nexus-rose mt-0.5">{cell.critical} CRIT</div>}
                          </div>
                        ) : (
                          <div className="text-nexus-text-3 text-[10px] font-mono">—</div>
                        )}
                      </td>
                    );
                  })}
                  <td className="p-3 text-center font-mono text-nexus-cyan text-[14px]">{totalAgents}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
